import React from 'react';
import { Dialog } from '@headlessui/react';
import { PoliticalOrg } from '../../../types/PoliticalOrg';
import { getOrgDisplayNameFromOrg, getOrgLogoFromOrg } from '../../../utils/politicalOrgHelpers';

interface OrgConfirmModalProps {
  savedOrg: PoliticalOrg;
  onProceed: () => void;
  onChange: () => void;
  onClose: () => void;
}

const OrgConfirmModal: React.FC<OrgConfirmModalProps> = ({
  savedOrg,
  onProceed,
  onChange,
  onClose,
}) => {
  return (
    <Dialog open={true} onClose={onClose} className="fixed inset-0 flex items-center justify-center z-50">
      <div className="fixed inset-0 bg-black bg-opacity-50" />

      <div className="bg-white rounded-lg p-6 z-50 w-full max-w-md mx-auto">
        <Dialog.Title className="text-xl font-semibold text-center mb-4">
          Confirm Your Organization
        </Dialog.Title>

        <div className="flex flex-col items-center gap-4 mb-6">
          <img
            src={getOrgLogoFromOrg(savedOrg)}
            alt={getOrgDisplayNameFromOrg(savedOrg)}
            className="w-16 h-16 rounded-full object-contain border border-gray-300"
          />
          <p className="text-lg font-medium">{getOrgDisplayNameFromOrg(savedOrg)}</p>
        </div>

        <div className="flex justify-between gap-4">
          <button
            onClick={onChange}
            className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-800 font-semibold py-2 px-4 rounded-md transition"
          >
            Change
          </button>
          <button
            onClick={onProceed}
            className="flex-1 bg-primary hover:bg-green-600 text-white font-semibold py-2 px-4 rounded-md transition"
          >
            Proceed
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default OrgConfirmModal;
